import { defineStore } from "pinia";

// 图片对象接口
interface ImageObject {
  src: string;
  title?: string;
  alt?: string;
}

// 图片查看器store
export const useImageViewerStore = defineStore("imageViewer", {
  state: () => ({
    visible: false,
    images: [] as (string | ImageObject)[],
    index: 0,
  }),

  actions: {
    /**
     * 显示图片查看器
     * @param images 图片数组
     * @param index 当前图片索引
     */
    show(images: string[], index: number = 0) {
      // 将字符串数组转换为带标题的对象数组
      this.images = images.map((src, i) => ({
        src,
        title: `${i + 1} / ${images.length}`,
        alt: `pic ${i + 1}`,
      }));
      this.index = Math.min(index, images.length - 1);
      this.visible = true;
    },

    /**
     * 隐藏图片查看器
     */
    hide() {
      this.visible = false;
    },
  },
});
